export const textLinkData = [
  { href: "#features", label: "Features" },
  { href: "#pasta", label: "PASTA & STRIDE" },
  { href: "#pricing", label: "Pricing" }
];

export const features = [
  { variant: "servicenow", title: "ServiceNow", description: "Automatically sync threats and risk metrics to ServiceNow." },
  { variant: "integrate-sca-sast-and-dast-findings-into-", eyebrow: "Veracode", title: "Integrate SCA, SAST, and DAST findings into your threat models." },
  { variant: "integrate-sast-dast-sca-iac-and-secret-det", eyebrow: "GitLab Secure", title: "Integrate SAST, DAST, SCA, IaC and Secret Detection findings from GitLab Secure into your application threat models." },
  { variant: "source-real-time-threat-intelligence-infor", eyebrow: "OpenCTI", title: "Source real-time threat intelligence information from OpenCTI." },
  { variant: "sync-threat-insights-and-risk-data-streaml", eyebrow: "Archer", title: "Sync threat insights and risk data, streamlining risk management." },
  { variant: "embed-real-time-threat-intelligence-and-in", eyebrow: "Mandiant", title: "Embed real-time threat intelligence and incident response data into your threat models." },
  { variant: "qualys", title: "Qualys", description: "Ingest your vulnerability scans and compliance reports." },
  { variant: "import-continuous-vulnerability-assessment", eyebrow: "Tenable", title: "Import continuous vulnerability assessments and asset risk scores." },
  { variant: "integrate-static-code-analysis-results-and", eyebrow: "Checkmarx", title: "Integrate static code analysis results and secure coding insights." },
  { variant: "import-cloud-security-posture-management-d", eyebrow: "AltorCloud", title: "Import cloud security posture management data and compliance reports." }
];

export const features2 = [
  { title: "01", description: "Define Objectives" },
  { title: "02", description: "Define Attack Surface" },
  { title: "03", description: "Decompose Application" },
  { title: "04", description: "Threat Analysis" },
  { title: "05", description: "Weakness & Vulnerability Analysis" },
  { title: "06", description: "Attack Modeling & Simulation" },
  { title: "07", description: "Risk & Impact Analysis" }
];

export const features3 = [
  { title: "Risk-Centric Focus", description: "Prioritizes threats based on business impact rather than just technical vulnerabilities." },
  { title: "Real-World Simulation", description: "Emulates realistic attack scenarios to uncover potential architectural weaknesses." },
  { title: "Comprehensive Analysis", description: "Merges technical telemetry and business risk perspectives for a well-rounded threat assessment." },
  { title: "Iterative AI Process", description: "Sentry 2.0 AI continuously refines threat models and mitigations as code evolves." }
];

export const features4 = [
  { variant: "fork-community", title: "ThreatForge Community", description: "Essential threat modeling functionalities designed to help you secure your application for free." },
  { variant: "fork-enterprise", title: "ThreatForge Enterprise", description: "Unlock enterprise-grade threat modeling capabilities for scale with Sentry 2.0 AI.", label: "Contact sales" },
  { variant: "fork-enterprise-pt", title: "ThreatForge Enterprise PT", description: "Request on-demand security testing directly from your application threat models.", label: "Contact sales" }
];

export const listRowData = [
  { href: "/#features", label: "Features" },
  { href: "/#pasta", label: "PASTA & STRIDE" },
  { href: "/#pricing", label: "Pricing" }
];

export const listRow2Data = [
  { href: "#", label: "About" },
  { href: "#", label: "Careers" },
  { href: "#", label: "Blog" }
];

export const listRow2Data2 = [
  { href: "/login", label: "Help Center" },
  { href: "#", label: "Threat Libraries" },
  { href: "/login", label: "Contact" }
];
